import React from 'react';

const CopyrightFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '8px 16px',
        background: 'rgba(0, 0, 0, 0.3)',
        color: 'rgba(255, 255, 255, 0.5)',
        fontSize: '11px',
        textAlign: 'center',
        zIndex: 100,
      }}
    >
      © {currentYear} BDP vLab - Developed by Iraj Mehrnia
    </footer>
  );
};

export default CopyrightFooter;
